export function distance(point1: GeoJSON.Point, point2: GeoJSON.Point): number {
	const lat1 = point1.coordinates[1]
	const lon1 = point1.coordinates[0]
	const lat2 = point2.coordinates[1]
	const lon2 = point2.coordinates[0]
	if (lat1 == lat2 && lon1 == lon2) {
		return 0
	} else {
		const radlat1 = (Math.PI * lat1) / 180
		const radlat2 = (Math.PI * lat2) / 180
		const theta = lon1 - lon2
		const radtheta = (Math.PI * theta) / 180
		let dist =
			Math.sin(radlat1) * Math.sin(radlat2) +
			Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta)
		if (dist > 1) {
			dist = 1
		}
		dist = Math.acos(dist)
		dist = (dist * 180) / Math.PI
		dist = dist * 60 * 1.1515
		dist = dist * 1.609344
		return dist
	}
}

export function metersToPixels(meters: number, zoom: number) {
	// Approximate latitude @TODO move this in DB ?
	const latitude = 46
	// Resolution in meters per pixel for Web Mercator projection at zoom level 0
	const baseResolution = 156543.03392
	const resolution =
		(baseResolution * Math.cos((latitude * Math.PI) / 180)) /
		Math.pow(2, zoom)
	return meters / resolution
}
